import * as React from "react";
import * as ReactDOM from "react-dom";

import { Groopit } from "./Groopit";
import {
  AssignmentDTO,
  GroopItModel_V1 as GroopitModel,
  useGroopitApiContext,
} from "groopit-js";
import { useState } from "react";
import { CircularProgress, ThemeProvider } from "@material-ui/core";
import { GroupContextProvider } from "groopit-js";
import { groopTheme } from "../styles/MaterialGroopTheme";
import useLatestRef from "../react/react-use/useLatestRef";
import { useEffectOnce } from "react-use";

interface Props {
  groopit_id: string;
  print?: boolean;
  is_popover: boolean;
}

export const GroopitDetails = (props: Props): JSX.Element => {
  const { groopit_id, print, is_popover } = { ...props };

  const [groopit, setGroopit] = useState<GroopitModel>();
  const [assignment, setAssignment] = useState<AssignmentDTO>();
  const api = useLatestRef(useGroopitApiContext());

  useEffectOnce(() => {
    const loadGroopit = async () => {
      const g = await api.current.groopit.getGroopIt(groopit_id);
      setGroopit(g);
      const a = await api.current.assignment.getAssignment(g.assignmentId);
      setAssignment(a);
      if (print) {
        window.print();
      }
    };

    loadGroopit();
  });

  return groopit && assignment ? (
    <Groopit
      groopit={groopit}
      assignment={assignment}
      is_popover={is_popover}
    ></Groopit>
  ) : (
    <div className="text-center">
      <CircularProgress />
    </div>
  );
};

const groopitdetails = document.querySelector(".groopitdetails") as HTMLElement;
if (groopitdetails) {
  ReactDOM.render(
    <GroupContextProvider
      groopId={groopitdetails.dataset.groopid as string}
      user_id={groopitdetails.dataset.userid as string}
      pictureImageBase={groopitdetails.dataset.pictureimagebase as string}
    >
      <ThemeProvider theme={groopTheme}>
        <GroopitDetails
          print={groopitdetails.dataset.print === "True"}
          groopit_id={groopitdetails.dataset.groopit as string}
          is_popover={false}
        />
      </ThemeProvider>
    </GroupContextProvider>,
    groopitdetails,
  );
}
